// broadcast label list directive
//
//   <broadcast-label-list broadcast="broadcast" />

let module = angular.module('app.directives');

module.directive('broadcastLabelList', ($rootScope) => {
  'ngInject';

  return {
    restrict: 'E',
    scope: { broadcast: '=' },
    template: `
      <ul class="list-inline">
        <li ng-if="broadcast.timeframe == 'current'">
          <span class="label label-danger">LIVE</span>
        </li>
        <li ng-if="broadcast.timeframe == 'preroll'">
          <span class="label label-warning"><i class="fa fa-spin fa-cog"></i> Preparing to Stream</span>
        </li>
        <li ng-if="broadcast.timeframe == 'future'">
          <span class="label label-warning">Starts <span am-time-ago="broadcast.starts_at"></span></span>
        </li>
        <li ng-if="broadcast.timeframe == 'past'">
          <span class="label label-default">Ended <span am-time-ago="broadcast.stops_at"></span></span>
        </li>
        <li ng-if="broadcast.is_ticketed">
          <span class="label label-success">\${{broadcast.ticket_price | number:2}} / ticket</span>
        </li>
        <li ng-if="broadcast.is_ticketed && broadcast.free_variant != 'none'">
          <span class="label label-success">Free {{broadcast.free_variant}}</span>
        </li>
        <li ng-if="broadcast.is_private">
          <span class="label label-default" style="background:#000">Private</span>
        </li>
        <li ng-if="broadcast.transcoder_profile">
          <span ng-if="showLimitTranscoder()" uib-tooltip="Limited to {{showLimitTranscoder()}} for viewers" class="label label-default">{{fixTranscoderProfile(broadcast.transcoder_profile)}}*</span>
          <span ng-if="!showLimitTranscoder()" class="label label-default">{{fixTranscoderProfile(broadcast.transcoder_profile)}}</span>
        </li>
        <li ng-if="broadcast.actual_codec == 'hevc'">
          <span class="label label-default">HEVC</span>
        </li>
      </ul>
    `,
    link: (scope, element, attrs) => {
      scope.fixTranscoderProfile = function (transcoder_profile) {
        // :hevc can be removed as it's accounted for elsewhere
        // :us is meaningless to customers
        var tp = transcoder_profile.replace(/:.*/, '');
        if (tp == 'audio') {
          tp = 'Audio';
        }
        return tp;
      };
      scope.showLimitTranscoder = function () {
        var resolution = parseInt(
          scope
            .fixTranscoderProfile(scope.broadcast.transcoder_profile || '')
            .replace('p60', '')
            .replace('p', ''),
          10
        );
        if ($rootScope.account.resolution_limit < resolution) {
          return `${$rootScope.account.resolution_limit}p`;
        } else {
          return null;
        }
      };
    },
  };
});

export default module;



// WEBPACK FOOTER //
// ./app/directives/broadcast-label-list.js